import type { BlogAuthor } from "@/content/blog/types";
import { DEFAULT_BLOG_AUTHOR } from "@/content/blog/authors";

export function BlogByline({ author = DEFAULT_BLOG_AUTHOR }: { author?: BlogAuthor }) {
  return <section className="flex items-start gap-4 py-5 border-b border-border mb-6" aria-label="About the author">
    {author.photoUrl && <img src={author.photoUrl} alt={author.kind === "person" ? author.name : "LeadXkids editorial team logo"} width={64} height={64} className="size-16 object-contain rounded-md shrink-0" loading="lazy" />}
    <div className="min-w-0">
      <p className="text-sm font-semibold text-foreground">By {author.name}</p>
      {author.role && <p className="text-xs text-muted-foreground mt-1">{author.role}</p>}
      {author.bio && <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{author.bio}</p>}
      <a href="/blog/authors" className="text-xs text-primary underline inline-block mt-2">Authors</a>
    </div>
  </section>;
}